import React, { useState, useCallback } from "react";
import { Button, Modal } from 'react-bootstrap';
import { NotificationManager } from "react-notifications";
import axios from "axios"; // Assurez-vous que axios est importé

export default function AddLangue({ idCv }) {
    const [show, setShow] = useState(false);
    const [langue, setLangue] = useState({
        langue: '',
        progress: ''
    });

    const pourcentages = Array.from({ length: 10 }, (_, i) => (i + 1) * 10); // Génère [10, 20, 30, ..., 100]

    // Gestion du changement des champs
    const handleChange = (e) => {
        const { name, value } = e.target;
        setLangue(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Validation basique du formulaire
    const validateForm = () => {
        if (!langue.langue) {
            NotificationManager.warning('Veuillez entrer une langue.', 'Erreur', 4000);
            return false;
        }
        if (!langue.progress) {
            NotificationManager.warning('Veuillez sélectionner une progression.', 'Erreur', 4000);
            return false;
        }
        return true;
    };

    // Enregistrement des données
    const handleExp = useCallback(async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append('langue', langue.langue);
        formData.append('progresslangue', langue.progress);
        formData.append('cv_id', idCv);

        try {
            const resp = await axios.post('langages', formData);
            if (resp.status === 201) {
                NotificationManager.success('Information enregistrée avec succès', 'Succès', 4000);
                setShow(false); // Fermer la modal après succès
            } else {
                NotificationManager.warning('Une erreur est survenue lors de l\'enregistrement.', 'Erreur', 4000);
            }
        } catch (error) {
            NotificationManager.error("Une erreur est survenue lors de l'enregistrement.", 'Erreur', 4000);
            console.error(error);
        }
    }, [langue, idCv]);

    return (
        <>
            <Button variant="info" onClick={() => setShow(true)}>
                <b>+</b> Ajouter une langue
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une langue</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label htmlFor="langue" className="form-label">Langue</label>
                            <input
                                id="langue"
                                name="langue"
                                required
                                value={langue.langue}
                                onChange={handleChange}
                                maxLength={50}
                                className="form-control mb-2"
                                type="text"
                                placeholder="Ajouter une langue"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Progression (échelle jusqu'à 100 %)</label>
                            <select
                                name="progress"
                                value={langue.progress}
                                onChange={handleChange}
                                className="form-control mb-2"
                            >
                                <option value="" disabled>Sélectionner une progression</option>
                                {pourcentages.map((cent) => (
                                    <option value={cent} key={cent}>
                                        {cent} %
                                    </option>
                                ))}
                            </select>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleExp}>
                        Enregistrer
                    </Button>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
